module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAAXNSR0IArs4c6QAAAGZQTFRFAAAA////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////lZ9pqAAAACF0Uk5TAAECAyY3PD0+QEJIbYCBgoOEnqGivL3Awc3P2t7g7/P9DDgWBAAAALxJREFUSMftlm0PgiAURgmKG2ZBJRS92f3/fzIGa0uTyKUrq/Ptup25ZzsfIOS3GZfnOvuHgsB7himspUQ8Srn11ywwHcUFQQjihpB55U+TtoKIC9YYxJMxh2eFZroUMkrdBkoX/qI0SwnV0TdfY0IOgLgDWPkLIH//6EIpl4ZSIQ2lis5Htxas1i4NrUMaWtsPSIMxt4GxkAZjPaTBuUuD85AG5/80BpJGf8I1gmZcMHUBU7wsLFN80XvhAimtdk1vxu0ZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/newImages/but_ic_ruzhu.png
// module id = 0eEY
// module chunks = 1